import { Stack, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useGetProjectMembersQuery } from "../../../../openapi";
import { FailedAlert, MCLoader } from "../../../components";
import { useAppDispatch } from "../../../hooks";
import IssueboardIdUrlSync from "../../IssueboardIdUrlSync";
import { useGetProjectQuery } from "../../projectRTK";
import { getProjectIdFromUrl } from "../../utils";
import { useGetSingleIssueBoardQuery } from "./IssueBoardRTK";
import IssueTabs from "./IssueTabs";
import IssueBoardMcTemplateBanner from "./IssuesTab/IssueBoardMcTemplateBanner";
import IssueMobileView from "./IssuesTab/IssueMobileView/IssueMobileView";
import IssueTab from "./IssuesTab/IssueTab";
import { IssueLogsGrid } from "./LogTab/IssueLogsGrid";
import IssueSettingsTab from "./SettingsTab/IssueSettingsTab";
import { setIssueActiveViewInRedux } from "./issueSlice";

const IssueApp: React.FC<{ issueBoardId: string }> = ({ issueBoardId }) => {
  const [activeTab, setActiveTab] = useState("issues");

  const history = useHistory();
  const projectId = getProjectIdFromUrl(history.location.pathname);

  const { data: project, isLoading: projectloading } = useGetProjectQuery(projectId);
  useGetProjectMembersQuery({ projectId }, { skip: project == null });

  const dispatch = useAppDispatch();

  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`, undefined, {
    getInitialValueInEffect: true,
  });

  const {
    data: singleIssueBoard,
    error,
    isLoading,
    refetch: refetchIssueBoard,
  } = useGetSingleIssueBoardQuery(
    {
      projectId: project?._id,
      issueBoardId: issueBoardId,
    },
    {
      skip: projectloading === true || project?._id == null,
    },
  );

  useEffect(() => {
    if (singleIssueBoard != null) {
      if (singleIssueBoard.defaultView != null && singleIssueBoard.defaultView !== "NONE") {
        dispatch(setIssueActiveViewInRedux(singleIssueBoard.defaultView));
      }
    }
  }, [singleIssueBoard?._id]);

  const isLoading_ = projectloading || isLoading;
  const isError = error;

  return (
    <Stack gap={0} w="100%" h="100%" className="overflow-auto">
      <IssueboardIdUrlSync />
      {singleIssueBoard?.template.isTemplate && <IssueBoardMcTemplateBanner />}
      {isLoading_ && <MCLoader loading={isLoading_} />}
      {isError && <FailedAlert />}
      {isLoading_ === false && !isError && singleIssueBoard != null && (
        <>
          {isMobile ? (
            <IssueMobileView issueBoard={singleIssueBoard} />
          ) : (
            <>
              <IssueTabs activeTab={activeTab} setActiveTab={setActiveTab} activeBoard={singleIssueBoard} />
              {activeTab === "issues" && <IssueTab setActiveTab={setActiveTab} />}
              {activeTab === "settings" && <IssueSettingsTab />}
              {activeTab === "logs" && <IssueLogsGrid />}
            </>
          )}
        </>
      )}
    </Stack>
  );
};

export default IssueApp;
